import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { contentCountriesQuery } from "./contentItem.queries";
import { buildContentCountriesRankedList } from "./contentItem.utils";
import RankedQueryCard from "../charts/RankedQueryCard";

import type { JSX } from "react";

import type { GetContentCountriesResponse } from "@/src/api/StatsAPI.types";
import type { AppState } from "@/src/reducers";

import type { ContentItemPeriodProps } from "./contentItem.types";
import type { ChartSeries, ViewsSeriesKey } from "../charts/charts.types";

function ContentCountriesRankedCard({
  contentId,
  period,
}: ContentItemPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t, i18n } = useTranslation("editor-analytics");
  const lang = i18n.language;
  const countries = useSelector(
    (state: AppState) => state.fetchReducer.countries,
  );

  const seriesList = useMemo(
    (): ChartSeries<ViewsSeriesKey>[] => [
      {
        key: "views",
        label: t("charts.series.views"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetContentCountriesResponse | undefined) =>
      buildContentCountriesRankedList(response, countries, lang),
    [countries, lang],
  );

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      query={contentCountriesQuery(projectSlug, contentId, period)}
      seriesList={seriesList}
      title={t("charts.countriesRanking")}
    />
  );
}

export default ContentCountriesRankedCard;
